import { chakra } from "@chakra-ui/system"

export function AmazonMusic(props: any) {
  return (
    <chakra.svg viewBox="0 0 90 90" {...props}>
      <linearGradient
        id="prefix__ab"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.358}
        x2={-349.234}
        y2={353.358}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M59.7 40.5c-.6.4-1.5.7-2.6.7-1.7 0-3.3-.2-4.9-.7-.4-.1-.7-.2-.9-.2-.3 0-.4.2-.4.6v1c0 .3.1.5.2.7.1.1.3.3.6.4 1.6.7 3.4 1 5.4 1 2.1 0 3.7-.5 5-1.5 1.3-1 1.9-2.3 1.9-4 0-1.2-.3-2.1-.9-2.9-.6-.7-1.6-1.4-3-1.9l-2.8-1.1c-1.1-.4-1.9-.8-2.2-1.2-.4-.4-.6-.8-.6-1.5 0-1.5 1.1-2.3 3.4-2.3 1.3 0 2.6.2 3.8.6.4.1.7.2.8.2.3 0 .5-.2.5-.6v-1c0-.3-.1-.5-.2-.7-.1-.2-.3-.3-.6-.4-1.5-.5-3-.8-4.5-.8-1.9 0-3.5.5-4.7 1.4-1.2.9-1.8 2.2-1.8 3.7 0 2.3 1.3 4 3.9 5l3 1.1c1 .4 1.6.7 2 1.1.4.4.5.8.5 1.4 0 .8-.3 1.5-.9 1.9z"
        fill="url(#prefix__ab)"
      />
      <linearGradient
        id="prefix__b"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.454}
        x2={-349.234}
        y2={353.454}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M44 26.1v13.3c-1.7 1.1-3.4 1.7-5.1 1.7-1.1 0-1.9-.3-2.4-.9-.5-.6-.7-1.5-.7-2.8V26.1c0-.5-.2-.7-.7-.7H33c-.5 0-.7.2-.7.7v12.4c0 1.7.4 3.1 1.3 4 .9.9 2.2 1.4 3.9 1.4 2.3 0 4.6-.8 6.8-2.4l.2 1.2c0 .3.1.4.3.5.1.1.3.1.6.1h1.5c.5 0 .7-.2.7-.7V26.1c0-.5-.2-.7-.7-.7h-2.1c-.6 0-.8.3-.8.7z"
        fill="url(#prefix__b)"
      />
      <linearGradient
        id="prefix__c"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.593}
        x2={-349.234}
        y2={353.593}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M25 43.4h2.1c.5 0 .7-.2.7-.7V30.2c0-1.7-.4-3-1.3-3.9-.9-.9-2.1-1.4-3.8-1.4-2.3 0-4.7.8-7 2.5-.8-1.7-2.3-2.5-4.5-2.5s-4.4.8-6.6 2.3l-.2-1.1c0-.3-.1-.4-.3-.5-.1-.1-.3-.1-.5-.1H2c-.5 0-.7.2-.7.7v16.6c0 .5.2.7.7.7h2.1c.5 0 .7-.2.7-.7V29.3c1.7-1 3.4-1.6 5.2-1.6 1 0 1.7.3 2.1.9.4.6.7 1.4.7 2.6v11.5c0 .5.2.7.7.7h2.1c.5 0 .7-.2.7-.7V29.8v-.5c1.8-1.1 3.5-1.6 5.2-1.6 1 0 1.7.3 2.1.9.4.6.7 1.4.7 2.6v11.5c0 .5.2.7.7.7z"
        fill="url(#prefix__c)"
      />
      <linearGradient
        id="prefix__d"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.333}
        x2={-349.234}
        y2={353.333}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M79.5 56.7c-10.9 4.6-22.8 6.9-33.6 6.9-16 0-31.5-4.4-44-11.7-.2-.1-.4-.2-.6-.2-.7 0-1.1.8-.4 1.5 11.6 10.5 27 16.8 44 16.8 12.2 0 26.3-3.8 36-11 1.7-1.2.3-3-1.4-2.3z"
        fill="url(#prefix__d)"
      />
      <linearGradient
        id="prefix__e"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.219}
        x2={-349.234}
        y2={353.219}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M79.2 29.4c.9-1 2.3-1.5 4.3-1.5 1 0 2 .1 2.9.4.3.1.4.1.6.1.3 0 .5-.2.5-.7v-1c0-.3-.1-.6-.2-.7-.1-.1-.3-.3-.5-.4-1.3-.3-2.6-.6-3.8-.6-2.8 0-4.9.8-6.5 2.5-1.5 1.6-2.3 4-2.3 7s.7 5.3 2.2 6.9c1.5 1.6 3.6 2.4 6.4 2.4 1.5 0 2.9-.2 4-.7.3-.1.5-.2.6-.4.1-.1.1-.4.1-.7v-1c0-.5-.2-.7-.5-.7-.1 0-.3 0-.5.1-1.1.3-2.2.5-3.2.5-1.9 0-3.3-.5-4.2-1.5-.9-1-1.3-2.6-1.3-4.7v-.5c.1-2.2.5-3.8 1.4-4.8z"
        fill="url(#prefix__e)"
      />
      <linearGradient
        id="prefix__f"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.104}
        x2={-349.234}
        y2={353.104}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M83.7 66.1c5.2-4.4 6.6-13.5 5.5-14.9-.5-.6-2.9-1.2-5.9-1.2-3.2 0-7 .7-9.9 2.7-.9.6-.7 1.4.2 1.3 3.1-.4 10.1-1.2 11.4.4 1.2 1.6-1.4 8.2-2.6 11.1-.3.9.4 1.2 1.3.6z"
        fill="url(#prefix__f)"
      />
      <linearGradient
        id="prefix__g"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.296}
        x2={-349.234}
        y2={353.296}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M69.8 25.4h-2.1c-.5 0-.7.2-.7.7v16.6c0 .5.2.7.7.7h2.1c.5 0 .7-.2.7-.7V26.1c0-.4-.2-.7-.7-.7z"
        fill="url(#prefix__g)"
      />
      <linearGradient
        id="prefix__h"
        gradientUnits="userSpaceOnUse"
        x1={-349.858}
        y1={353.374}
        x2={-349.234}
        y2={353.374}
        gradientTransform="scale(128.6857 -128.6857) rotate(45 252.364 598.9)"
      >
        <stop offset={0} stopColor="#0c6cb3" />
        <stop offset={0.291} stopColor="#1e84c4" />
        <stop offset={0.887} stopColor="#4cc0ef" />
        <stop offset={1} stopColor="#4cc0ef" />
      </linearGradient>
      <path
        d="M70.4 18.6c-.4-.4-1-.6-1.7-.6s-1.2.2-1.6.6c-.4.4-.6.9-.6 1.5s.2 1.2.6 1.5c.4.4.9.6 1.6.6.7 0 1.2-.2 1.6-.6.4-.4.6-.9.6-1.5s-.1-1.2-.5-1.5z"
        fill="url(#prefix__h)"
      />
    </chakra.svg>
  )
}


